import React from 'react';
import { Formik } from 'formik';

import ClientCustomerSupportRequestFormView from './ClientCustomerSupportRequestFormView';
import Typography from '@material-ui/core/Typography';

import { validateRequiredFields, validateInputLength } from 'utils/formValidations';

import { DESCRIPTION_MAX_LENGTH } from '../../../CustomerSupportConstants';
import SectionActionsWrapper from 'components/Shared/SectionActionsWrapper/SectionActionsWrapper';

const ClientCustomerSupportRequestForm = ({
    requestCustomerSupport,
    accountManager,
}) => {
    return (
        <Formik
            initialValues={{
                name: '',
                description: ''
            }}

            validate={values => {
                return {
                    ...validateRequiredFields(values, ['name', 'description']),
                    ...validateInputLength(values, [
                        { property: 'description', maxLength: DESCRIPTION_MAX_LENGTH },
                    ]),
                }
            }}

            onSubmit={(values, { resetForm, setSubmitting }) => {
                setSubmitting(false);
                requestCustomerSupport({ ...values, accountManager });
                resetForm();
            }}
        >
            {(props) => (
                <div className="client-customer-support-request-container">
                    <SectionActionsWrapper>
                        <SectionActionsWrapper.SectionTitle sectionTitle="Customer Support" />
                    </SectionActionsWrapper>
                    <div className="client-customer-support-form-content">
                        <Typography className="content-title" variant="h4">How can we help?</Typography>
                        <Typography className="content-helper-text" variant="h5">
                            If you're experiencing problems that you need help with, please complete the form below and our customer support team will get back to you within 48 hours.
                        </Typography>
                        <ClientCustomerSupportRequestFormView {...props} />
                    </div>
                </div>
            )}
        </Formik>
    );
};

export default ClientCustomerSupportRequestForm;
